import { render, staticRenderFns } from "./sh_StatisticsChart.vue?vue&type=template&id=be6aec82&scoped=true&"
import script from "./sh_StatisticsChart.vue?vue&type=script&lang=js&"
export * from "./sh_StatisticsChart.vue?vue&type=script&lang=js&"
import style0 from "./sh_StatisticsChart.vue?vue&type=style&index=0&id=be6aec82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6aec82",
  null
  
)

export default component.exports